import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import NavMobile from "../../Nav/NavMobile";
import NavWeb from "../../Nav/NavWeb";
import { Button } from "../../../ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../ui/table";
import EditarClasesEnMasa from "../../EstudiantesPrivados/Dashboard/EditarClasesEnMasa";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../../../ui/alert-dialog";
import "./GrupoDetalle.css";
import CrearModGrupo from "../CrearModGrupo";
import { BellIcon, DownloadIcon, PersonIcon } from "@radix-ui/react-icons";
import Calendar from "../../EstudiantesPrivados/Dashboard/Calendar";
import Chart from "../../EstudiantesPrivados/Dashboard/Chart";
import PieChart from "../../EstudiantesPrivados/Dashboard/Chart2";
import { getClassesByParticipantIDAndDateTimeBetween } from "../../../../provider/adm/Clases/getClassesByParticipantIDAndDateTimeBetween";
import { Dialog, DialogContent, DialogTrigger } from "../../../ui/dialog";
import { TrashIcon } from "@radix-ui/react-icons";
import { Pencil1Icon } from "@radix-ui/react-icons";
import Loader from "../../../Loader/Loader";
import { deleteClass } from "../../../../provider/adm/Clases/deleteClass";
import ModificarClasesGrupo from "./classes/ModificarClasesGrupo";
import { dashboardParticipant } from "../../../../provider/adm/dashboard/dashboardParticipant";
import { Toaster } from "sonner";
const GroupDetail = () => {
  const [groupData, setGroupData] = useState();
  const [classes, setClasses] = useState([]);
  const [date, setDate] = useState([]);
  const [inforDashboard, setInforDashboard] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [exportFormat, setExportFormat] = useState("excel"); // Estado para el formato de exportación

  // Estados para los filtros
  const [filters, setFilters] = useState({
    idClase: '',
    fecha: '',
  });

  // Función para manejar cambios en los filtros
  const handleFilterChange = (filterType, value) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: value
    }));
  };

  // Función para limpiar filtros
  const clearFilters = () => {
    setFilters({
      idClase: '',
      fecha: '',
    });
  };

  // Función para filtrar las clases
  const filteredClasses = classes.filter(classData => {
    const matchesId = !filters.idClase || 
      classData.id.toString().toLowerCase().includes(filters.idClase.toLowerCase());
    
    const matchesFecha = !filters.fecha || 
      new Date(classData.dateTime).getDate().toString() === filters.fecha;
    
    return matchesId && matchesFecha;
  });

  // Función para manejar la selección individual
  const handleSelectClass = (classId) => {
    setSelectedClasses((prev) =>
      prev.includes(classId)
        ? prev.filter((id) => id !== classId)
        : [...prev, classId]
    );
  };

  // Función para seleccionar/deseleccionar todas
  const handleSelectAll = () => {
    if (selectedClasses.length === filteredClasses.length && filteredClasses.length > 0) {
      setSelectedClasses([]);
    } else {
      setSelectedClasses(filteredClasses.map((c) => c.id));
    }
  };

  // Función para eliminar clases seleccionadas
  const handleDeleteSelected = async () => {
    if (selectedClasses.length === 0) return;

    const confirmReturnHours = window.confirm(
      "¿Deseas devolver las horas al grupo?"
    );

    setLoading(true);
    try {
      // Eliminar cada clase seleccionada una por una
      for (const classId of selectedClasses) {
        await deleteClass(classId, confirmReturnHours);
      }
      await refreshData();
      setSelectedClasses([]); // Limpiar selecciones
    } catch (error) {
      console.error("Error eliminando las clases:", error);
    } finally {
      setLoading(false);
    }
  };
  // Función para manejar el éxito de la edición masiva
  const handleMassEditSuccess = async () => {
    await refreshData();
    setSelectedClasses([]); // Limpiar selecciones
  };
  // Función para recargar datos
  const refreshData = async () => {
    if (window.refreshCalendarData) {
      await window.refreshCalendarData();
    } else {
      // Fallback: incrementa el trigger para forzar la recarga
      setRefreshTrigger((prev) => prev + 1);
    }
  };
  useEffect(() => {
    const data = localStorage.getItem("groupData");
    if (data) {
      setGroupData(JSON.parse(data));
    }

    // Recuperar fecha guardada o usar fecha actual
    const storedDate = localStorage.getItem("group_dashboard_date");
    if (storedDate) {
      setDate(JSON.parse(storedDate));
    } else {
      setDate({
        month: parseInt(new Date().getMonth().toString()) + 1,
        year: new Date().getFullYear().toString(),
      });
    }
  }, []);

  // Añadir este efecto para guardar la fecha cuando cambie
  useEffect(() => {
    if (date && date.month && date.year) {
      localStorage.setItem("group_dashboard_date", JSON.stringify(date));
    }
  }, [date]);

  const exportToExcel = async () => {
    try {
      setLoading(true);

      // Use the current date state values for the export
      const { year, month } = date;

      // Determine if it's PDF export
      const asPdf = exportFormat === "pdf";

      // Create the API URL with query parameters
      const apiUrl = `${process.env.REACT_APP_API_URL}/admin/equipo/exportar-por-Empresa?companyID=${groupData.companyID}&year=${year}&month=${month}${asPdf ? '&asPdf=true' : ''}`;
      const token = sessionStorage.getItem("token"); // Retrieve the JWT token from session storage

      // Set appropriate headers based on format
      const headers = {
        Authorization: `Bearer ${token}`,
        Accept: asPdf 
          ? "application/pdf"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      };

      // Fetch the file from the API
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        throw new Error(`Error al exportar: ${response.status}`);
      }

      // Get the file as a blob
      const blob = await response.blob();

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create filename based on format
      const fileExtension = asPdf ? "pdf" : "xlsx";
      const fileName = `Reporte_${groupData.companyName}_ano_${year}_mes_${month}.${fileExtension}`;

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.setAttribute("download", fileName);

      // Set additional attributes to try to force the save dialog
      link.setAttribute(
        "type",
        asPdf 
          ? "application/pdf"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      );
      link.setAttribute("target", "_blank");

      // Append to the document, trigger click, and then remove
      document.body.appendChild(link);
      link.click();

      // Remove the element and revoke the object URL to free up memory
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("Error al exportar el archivo:", error);
      // You could use the Toaster here to show an error message
    } finally {
      setLoading(false);
    }
  };

  if (!groupData || !date || !inforDashboard || !classes) {
    return <Loader />;
  }

  return (
    <div
      className="min-h-screen flex"
      style={{ overflowY: "hidden", height: "100vh" }}
    >
      {loading && <Loader />}
      <NavMobile />
      <NavWeb />
      <div className="dashboardgroup">
        <div className="dashboardcontainergroup">
          <div className="tituloynotificaciones">
            <h2 className="text-xl font-bold text-gray-900">
              Grupo {groupData.name} con id={groupData.ID}
            </h2>
            <BellIcon className="h-6 w-6" />
          </div>
          <div className="filtrosandbackbtn">
            <a href="/admin/gruposvista/grupos">
              <Button>Back</Button>
            </a>
            <div className="actions">
              <Calendar
                setDate={(date) => setDate(date)}
                date={date}
                ID={groupData.ID}
                setClasses={setClasses}
                getClasses={getClassesByParticipantIDAndDateTimeBetween}
                getInforDashboard={dashboardParticipant}
                setInforDashboard={setInforDashboard}
                setLoading={setLoading}
                refreshTrigger={refreshTrigger}
              />

              <Button
                onClick={() => {
                  const currentDate = new Date();
                  const dateObj = {
                    month: (currentDate.getMonth() + 1).toString(),
                    year: currentDate.getFullYear().toString(),
                  };
                  setDate(dateObj);
                  localStorage.removeItem("group_dashboard_date");
                }}
              >
                limpiar filtros
              </Button>
              <div className="flex items-center gap-2">
                <Select value={exportFormat} onValueChange={setExportFormat}>
                  <SelectTrigger className="w-32">
                    <SelectValue placeholder="Formato" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="excel">Excel</SelectItem>
                    <SelectItem value="pdf">PDF</SelectItem>
                  </SelectContent>
                </Select>
                <Button onClick={exportToExcel}>
                  <DownloadIcon />
                  Exportar
                </Button>
              </div>
              <a
                href={`/admin/gruposvista/grupos/groupdetail/studentsgroupcrud?nameGroup=${encodeURIComponent(
                  groupData.name
                )}&teamId=${groupData.ID}&year=${date.year}&month=${
                  date.month
                }`}
              >
                <Button>
                  <PersonIcon />
                  Ver todos
                </Button>
              </a>
            </div>
          </div>
          <div className="resumenDeActividadAcademica">
            <h3 className="text-xl font-bold mb-4 text-gray-800">Resumen de Actividad Académica</h3>
            
            {/* Sección de Horas */}
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-blue-600 border-b border-blue-200 pb-1">📚 Horas del Mes</h4>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="actividadCard bg-blue-50 border-l-4 border-blue-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Planeadas</h5>
                  <p className="text-2xl font-bold text-blue-600">{inforDashboard.hoursPlanned || 0}</p>
                </div>
                <div className="actividadCard bg-purple-50 border-l-4 border-purple-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Virtuales</h5>
                  <p className="text-2xl font-bold text-purple-600">{inforDashboard.hoursHeldVirtual || 0}</p>
                </div>
                <div className="actividadCard bg-orange-50 border-l-4 border-orange-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Presenciales</h5>
                  <p className="text-2xl font-bold text-orange-600">{inforDashboard.hoursHeldInPerson || 0}</p>
                </div>
                <div className="actividadCard bg-green-50 border-l-4 border-green-500">
                  <h5 className="text-sm font-medium text-gray-600">Horas Dictadas Totales</h5>
                  <p className="text-2xl font-bold text-green-600">{inforDashboard.hoursHeld || 0}</p>
                </div>
              </div>
            </div>

            {/* Sección de Cancelaciones */}
            <div className="mb-6">
              <h4 className="text-lg font-semibold mb-3 text-red-600 border-b border-red-200 pb-1">❌ Horas Canceladas</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div className="actividadCard bg-yellow-50 border-l-4 border-yellow-500">
                  <h5 className="text-sm font-medium text-gray-600">A Tiempo (Estudiante)</h5>
                  <p className="text-2xl font-bold text-yellow-600">{inforDashboard.hoursCanceledParticipantOnTime || 0}</p>
                </div>
                <div className="actividadCard bg-amber-50 border-l-4 border-amber-500">
                  <h5 className="text-sm font-medium text-gray-600">A Tiempo (Profesor)</h5>
                  <p className="text-2xl font-bold text-amber-600">{inforDashboard.hoursCanceledTeacherOnTime || 0}</p>
                </div>
                <div className="actividadCard bg-orange-50 border-l-4 border-orange-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde (Estudiante)</h5>
                  <p className="text-2xl font-bold text-orange-600">{(inforDashboard.hoursCanceledParticipantLateVirtual || 0) + (inforDashboard.hoursCanceledParticipantLateInPerson || 0)}</p>
                </div>
                <div className="actividadCard bg-red-50 border-l-4 border-red-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde (Profesor)</h5>
                  <p className="text-2xl font-bold text-red-600">{inforDashboard.hoursCanceledTeacherLate || 0}</p>
                </div>
                <div className="actividadCard bg-pink-50 border-l-4 border-pink-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde Virtual</h5>
                  <p className="text-2xl font-bold text-pink-600">{inforDashboard.hoursCanceledParticipantLateVirtual || 0}</p>
                </div>
                <div className="actividadCard bg-rose-50 border-l-4 border-rose-500">
                  <h5 className="text-sm font-medium text-gray-600">Tarde Presencial</h5>
                  <p className="text-2xl font-bold text-rose-600">{inforDashboard.hoursCanceledParticipantLateInPerson || 0}</p>
                </div>
              </div>
            </div>
          </div>
          {inforDashboard.monthlyClassStats && (
            <>
              <div className="pie">
                <PieChart data={inforDashboard} />
              </div>
              <div className="grafica">
                <Chart data={inforDashboard} />
              </div>
            </>
          )}

          <div className="informacionDetalladaEstudiante">
            <CrearModGrupo initialData={groupData} flag={1} />
          </div>
          <div className="ultimasclasesvistas">
            <Dialog>
              <DialogTrigger asChild>
                <Button>Crear Clase</Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-[825px]">
                <ModificarClasesGrupo
                  data={{}}
                  teamID={groupData.ID}
                  profesorAsignado={groupData.teacherDescription.fullName}
                  teacherID_fromButton={groupData.teacherDescription.id}
                />
              </DialogContent>
            </Dialog>

            {/* Filtros */}
            <div className="filters-section bg-gray-50 p-4 rounded-lg mb-4">
              <h3 className="text-lg font-semibold mb-3">Filtros</h3>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    ID Clase
                  </label>
                  <input
                    type="text"
                    placeholder="Buscar por ID..."
                    value={filters.idClase}
                    onChange={(e) => handleFilterChange('idClase', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Fecha (Día)
                  </label>
                  <input
                    type="number"
                    placeholder="Día (1-31)"
                    min="1"
                    max="31"
                    value={filters.fecha}
                    onChange={(e) => handleFilterChange('fecha', e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
                <div className="flex items-end">
                  <Button 
                    variant="outline" 
                    onClick={clearFilters}
                    className="w-full"
                  >
                    Limpiar Filtros
                  </Button>
                </div>
              </div>
            </div>

            {selectedClasses.length > 0 && (
              <div className="flex gap-2">
                <AlertDialog>
                  <AlertDialogTrigger asChild>
                    <Button variant="destructive">
                      <TrashIcon className="w-4 h-4 mr-2" />
                      Eliminar Seleccionadas ({selectedClasses.length})
                    </Button>
                  </AlertDialogTrigger>
                  <AlertDialogContent>
                    <AlertDialogHeader>
                      <AlertDialogTitle>¿Estás absolutamente seguro?</AlertDialogTitle>
                      <AlertDialogDescription>
                        Esta acción no se puede deshacer. Esto eliminará permanentemente{" "}
                        {selectedClasses.length} clase(s) y todos sus datos asociados.
                      </AlertDialogDescription>
                    </AlertDialogHeader>
                    <AlertDialogFooter>
                      <AlertDialogCancel>Cancelar</AlertDialogCancel>
                      <AlertDialogAction onClick={handleDeleteSelected}>
                        Sí, eliminar
                      </AlertDialogAction>
                    </AlertDialogFooter>
                  </AlertDialogContent>
                </AlertDialog>

                <Dialog>
                  <DialogTrigger asChild>
                    <Button variant="outline">
                      <Pencil1Icon className="w-4 h-4 mr-2" />
                      Editar Seleccionadas ({selectedClasses.length})
                    </Button>
                  </DialogTrigger>
                  <DialogContent className="sm:max-w-[600px]">
                    <EditarClasesEnMasa 
                      selectedClasses={selectedClasses.map(id => 
                        filteredClasses.find(cls => cls.id === id)
                      ).filter(Boolean)}
                      onSuccess={handleMassEditSuccess}
                    />
                  </DialogContent>
                </Dialog>
              </div>
            )}

            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>
                    <input
                      type="checkbox"
                      checked={
                        selectedClasses.length === filteredClasses.length &&
                        filteredClasses.length > 0
                      }
                      onChange={handleSelectAll}
                      className="rounded"
                    />
                  </TableHead>
                  <TableHead>ID clase</TableHead>
                  <TableHead>Teacher</TableHead>
                  <TableHead>Fecha</TableHead>
                  <TableHead>Modalidad</TableHead>
                  <TableHead>H. planeadas</TableHead>
                  <TableHead>Duracion</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {filteredClasses.map((classData) => (
                  <TableRow
                    key={classData.id}
                    className={
                      selectedClasses.includes(classData.id)
                        ? "bg-blue-50 border-blue-200"
                        : ""
                    }
                  >
                    <TableCell>
                      <input
                        type="checkbox"
                        checked={selectedClasses.includes(classData.id)}
                        onChange={() => handleSelectClass(classData.id)}
                        className="rounded"
                      />
                    </TableCell>
                    <TableCell>{classData.id}</TableCell>
                    <TableCell>{classData.teacherName}</TableCell>
                    <TableCell>
                      {new Date(classData.dateTime).toLocaleString("es", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                        timeZoneName: "short", 
                      })}
                    </TableCell>
                    <TableCell>{classData.classType}</TableCell>
                    <TableCell>{classData.plannedDuration} H</TableCell>
                    <TableCell>{classData.duration} H</TableCell>
                    <TableCell>
                      <div
                        className={`flex items-center justify-center p-1 rounded-lg text-white font-semibold ${
                          classData.classStatus === "Held"
                            ? "bg-green-500"
                            : classData.classStatus === "To be held"
                            ? "bg-gray-500"
                            : classData.duration > 0
                            ? "bg-orange-500"
                            : "bg-red-500"
                        }`}
                      >
                        <span className="w-2 h-2 rounded-full mr-3 bg-white"></span>
                        <span>
                          {classData.classStatus === "To be held"
                            ? "Por llenar"
                            : classData.classStatus === "Held"
                            ? "Completada"
                            : classData.duration > 0
                            ? "Parcial"
                            : "Cancelada"}
                        </span>
                      </div>
                    </TableCell>
                    <TableCell>
                      <Dialog>
                        <DialogTrigger asChild>
                          <Pencil1Icon className="w-6 h-6 text-gray-400 cursor-pointer" />
                        </DialogTrigger>
                        <DialogContent className="sm:max-w-[825px]">
                          <ModificarClasesGrupo
                            data={classData}
                            teamID={groupData.ID}
                          />
                        </DialogContent>
                      </Dialog>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            
            {filteredClasses.length === 0 && classes.length > 0 && (
              <div className="text-center py-8 text-gray-500">
                No se encontraron clases que coincidan con los filtros aplicados.
              </div>
            )}
          </div>
        </div>
      </div>
      <Toaster />
    </div>
  );
};

export default GroupDetail;
